const jwt = require('jsonwebtoken');

/**
 * A class to manage and deal with JWT Tokens
 * @param token - a String containing the signed jwt token
 * @constructor
 */
export class JWT {
  private _token: string;

  constructor(token: string) {
    this._token = token;
  }

  /**
 * Generate a valid jwt token, generally for testing
 */
  public static fromPayloadOptionsAndSecret(payload, options, secret) {
    return new JWT(jwt.sign(payload, secret, options));
  }

  /**
 * Get the internal token
 * @returns {.qs.id_token|*|id_token}
 */
  public token() {
    return this._token;
  }

  /**
 * Decode the jwt contents
 * @returns {object}
 */
  public decode() {
    return jwt.decode(this.token());
  }

  /***
 * Verify this signed token
 * @param secret - Buffer containing the secret
 * @param options - {issuer or audiance}
 * @param callback (err, dataObj)
 * @returns {*}
 */
  public verify(secret, options, callback?) {
    return jwt.verify(this.token(), secret, options, callback);
  }

  /**
 * Gets the seconds remaining on this token before it expires
 * @returns {number}
 */
  public timeLeft() {
    var decoded;
    try {
      decoded = jwt.decode(this.token());
    } catch (err) {
      decoded = null;
    }
    if (!decoded || !decoded.exp) {
      return null;
    }
    return decoded.exp - Math.floor(Date.now() / 1000);
  }
}
